import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import './CartDrawer.css';

interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}

const CartDrawer: React.FC<CartDrawerProps> = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { cartItems, updateQuantity, removeFromCart, getTotalPrice } = useCart();

  const handleQuantityChange = (itemId: string, delta: number) => {
    const item = cartItems.find((i) => i.id === itemId);
    if (item) {
      updateQuantity(itemId, item.quantity + delta);
    }
  };

  return (
    <>
      <div className={`cart-drawer-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}></div>
      <div className={`cart-drawer ${isOpen ? 'open' : ''}`}>
        <div className="cart-drawer-header">
          <h2>Giỏ hàng của bạn</h2>
          <button className="cart-drawer-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="cart-drawer-content">
          {cartItems.length === 0 ? (
            <div className="cart-empty">
              <p>Giỏ hàng của bạn đang trống</p>
            </div>
          ) : (
            <>
              <div className="cart-items">
                {cartItems.map((item) => (
                  <div key={item.id} className="cart-item">
                    <div className="cart-item-image">
                      <img src={item.product.image} alt={item.product.name} />
                    </div>
                    <div className="cart-item-details">
                      <h4>{item.product.name}</h4>
                      {(item.selectedSize || item.selectedColor || item.selectedMaterial) && (
                        <p className="cart-item-variant">
                          {item.selectedSize && `Kích thước: ${item.selectedSize}`}
                          {item.selectedColor && ` / Màu: ${item.selectedColor}`}
                          {item.selectedMaterial && ` / Chất liệu: ${item.selectedMaterial}`}
                        </p>
                      )}
                      <p className="cart-item-price">{item.product.price.toLocaleString('vi-VN')}đ</p>
                      <div className="cart-item-quantity">
                        <button onClick={() => handleQuantityChange(item.id, -1)} className="quantity-btn">-</button>
                        <span>{item.quantity}</span>
                        <button onClick={() => handleQuantityChange(item.id, 1)} className="quantity-btn">+</button>
                      </div>
                    </div>
                    <button className="cart-item-remove" onClick={() => removeFromCart(item.id)}>
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                ))}
              </div>

              <div className="cart-drawer-footer">
                <div className="cart-total">
                  <span>Tổng cộng</span>
                  <span className="cart-total-price">{getTotalPrice().toLocaleString('vi-VN')}đ</span>
                </div>
                <p className="cart-note">Phí vận chuyển, thuế và giảm giá sẽ được tính khi thanh toán.</p>
                <div className="cart-actions">
                  <button 
                    className="btn-checkout"
                    onClick={() => {
                      onClose();
                      navigate('/checkout');
                    }}
                  >
                    Thanh toán
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CartDrawer;

